import * as Sentry from '@sentry/browser';

/**
 * Check whether userData and clientData are valid, non-null objects.
 * Catches the three known failure paths: null/undefined, string from
 * a malformed API response, and array (raw response.data leaked through).
 */
export function isCoreDataValid(userData, clientData) {
	return userData && typeof userData === 'object' && !Array.isArray(userData) && clientData && typeof clientData === 'object' && !Array.isArray(clientData);
}

/**
 * Replace the #loading element with a user-friendly error message
 * and report the failure to Sentry so we can track frequency.
 *
 * @param {string} message  - User-visible text (HTML allowed)
 * @param {string} context  - Internal label for Sentry (e.g. "ReadyToRender guard")
 * @param {Object} [extra]  - Optional key/value pairs attached to the Sentry event
 */
export function showFatalError(message, context, extra) {
	const el = document.getElementById('loading');
	if (el) {
		el.innerHTML = `
			<div class="p-2 center-align" style="max-width: 600px; margin: 0 auto;">
				<div class="mb-4"><img src="./../../resources/assets/fix_car.webp" alt="Error" class="responsive-img" style="width:500px; height:auto;"/></div>
				<p class="text-secondary">${message}</p>
			</div>
		`;
	}
	console.error(`[showFatalError] ${context}:`, extra || '');
	Sentry.captureMessage(context, {
		level: 'error',
		extra: extra || {},
	});
}

// Instant feedback while a table row opens something slow (an admin campaign, say): the picked row is
// highlighted with a spinner, the other rows fade and stop taking clicks, the cursor shows progress.
// Call with null when done. Same look as Switch Account (main.css). Resolves once the feedback has painted,
// so a caller about to do heavy work can await it first.
export function showRowOpening(link) {
	const painted = new Promise((resolve) => requestAnimationFrame(() => setTimeout(resolve, 0)));
	document.body.style.cursor = link ? 'progress' : '';
	document.querySelectorAll('.row-opening-table').forEach((t) => t.classList.remove('row-opening-table'));
	document.querySelectorAll('tr.is-opening').forEach((r) => r.classList.remove('is-opening'));
	document.querySelectorAll('.row-opening-spinner').forEach((s) => s.remove());
	if (!link) return painted;
	const row = link.closest('tr');
	row?.classList.add('is-opening');
	row?.closest('table')?.classList.add('row-opening-table');
	link.insertAdjacentHTML('afterend', '<span class="row-opening-spinner" role="status" aria-label="Opening"></span>');
	return painted;
}
